import React from 'react';

import {getLayeredIcon} from '../../../../utils/common'
import './style.scss'

export default class RadioButton extends React.Component{

    constructor(props){
        super(props);
    }

    selectRadioButton=(name,value)=>{
        let {onChange} = this.props;
        onChange && onChange(name,value);
    }

    render(){
        let {options, value, name, radioClass, label,objectType=false} = this.props;
        return (<div className='radio-buttons'>
            {label && <span tabIndex="0" className='radio-label'>{label}</span>}
            {!objectType ?options && options.map((item,index)=>{
                return (<span key={index} className={`radio-option ${radioClass ?radioClass :''}`} onKeyPress={()=>this.selectRadioButton(name,item)} onClick={()=>this.selectRadioButton(name,item)}>
                    {value == item ? getLayeredIcon('icon-radio_checked') : <i tabIndex="0" className='icon-radio' />}
                    <span className='option-title'>{item}</span>
                </span>)
            }):options && Object.keys(options).map((item,index)=>{
                return (<span key={index} className={`radio-option ${radioClass ?radioClass :''}`} onKeyPress={()=>this.selectRadioButton(name,item)} onClick={()=>this.selectRadioButton(name,item)}>
                    {value ==options[item].id ? getLayeredIcon('icon-radio_checked') : <i tabIndex="0" className='icon-radio' />}
                    <span className='option-title'>{options[item].value}</span>
                </span>)
            })}
        </div>)
    }
}